import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { AppService } from '@core/services/app.service';
import { AuthService } from '@core/services/auth.service';
import { ExternalScriptsService } from '@core/services/external-scripts.service';
import { IconRegistryService } from '@core/services/icon-registry.service';
import { IconsService } from '@core/services/icons.service';

export const provideAppInitializer = (): (
  | Provider
  | EnvironmentProviders
)[] => {
  return [
    provideEnvironmentInitializer(() => inject(ExternalScriptsService)),
    provideEnvironmentInitializer(() => inject(AuthService)),
    provideEnvironmentInitializer(() => inject(AppService)),
    provideEnvironmentInitializer(() => inject(IconsService)),
    provideEnvironmentInitializer(() => inject(IconRegistryService)),
  ];
};
